export enum ContentCategoryType {
  ESTATE = 'estate',
  PARTNERS = 'partners',
  EVENTS = 'events',
  FEED = 'feed',
  SENIORS = 'seniors',
  CLUBS = 'clubs',
  PARTNERS_OFFERS = 'offers',
  VOTING = 'voting',
}
